import { ApiProperty } from "@nestjs/swagger";

export class RackZoneRequest{
    @ApiProperty()
    rackId:number;
    @ApiProperty()
    zoneId:number;
}